import { render } from "./Home.vue?vue&type=template&id=47596c98&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=47596c98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47596c98"]])

export default __exports__